import config from 'config';
import { deleteCookie, getCookie, responseError, responseErrorWithMessage } from 'helpers';
import { APIResponse } from 'types/Request';
import {
  FacturacionOOSSRequest,
} from 'types/FacturacionOOSS';

function revokeCredentials() {
  deleteCookie('accessToken');
  deleteCookie('sessionCookie');
  // eslint-disable-next-line no-restricted-globals
  return location.reload();
}

export async function getAllSolicitudesFacturacionOOSS(
  matricula: string | null = null,
): Promise<FacturacionOOSSRequest[] | []> {
  try {
    const url = new URL(`${ config.baseUrl }/facturacion-ooss/solicitudes`);

    type Response = APIResponse<FacturacionOOSSRequest[]>

    if (matricula) {
      const params = new URLSearchParams({
        matricula: matricula.toString(),
      });
      url.search = params.toString();
    }

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      return [];
    }

    const content = await response.json() as Response;

    if (content.status !== 'ok') {
      if (content.code === 'CONNECTION_ERROR') {
        return [];
      }

      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las prestaciones. ' +
        'Temporalmente no se podrá enviar la solicitud pero si guardar como Borrador. (1)');
    }

    return content.payload ?? [];
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las prestaciones. ' +
      'Temporalmente no se podrá enviar la solicitud pero si guardar como Borrador. (2)');
  }
}

export async function getFacturacionOOSSRequest(
  facturacionOOSSId: number,
): Promise<FacturacionOOSSRequest | undefined> {
  try {
    const url = new URL(`${ config.baseUrl }/matriculates/facturacion-ooss-request/${ facturacionOOSSId }`);

    type Response = APIResponse<FacturacionOOSSRequest>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      return;
    }

    const content = await response.json() as Response;

    if (content.status !== 'ok') {
      if (content.code === 'CONNECTION_ERROR') {
        return;
      }

      throw new Error(
        'Ocurrió un problema inesperado al momento de intentar recuperar la solicitud de facturación ooss.',
      );
    }

    return content.payload;
  } catch (err) {
    throw new Error(
      'Ocurrió un problema inesperado al momento de intentar recuperar la solicitud de facturación ooss.',
    );
  }
}

export async function postFacturacionOOSS(
  data: Partial<FacturacionOOSSRequest>,
  files: Record<string, File>,
  totpCode: string,
): Promise<any | undefined> {
  try {
    const formData = new FormData();

    Object.entries(files).forEach(([name, value]) => {
      formData.append(name, value);
    });

    formData.append('metadata', JSON.stringify(data));

    const res = await fetch(`${ config.baseUrl }/facturacion-ooss`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Authorization: getCookie('accessToken'),
        'x-totp-code': totpCode,
      },
      body: formData,
    });

    if (res.status === 400) return responseErrorWithMessage(res);

    if (res.status === 401 && true) {
      return revokeCredentials();
    }

    return res.json();
  } catch (err) {
    console.error('ApiService', 'Error de conexión al hacer POST de facturación ooss');
    console.info(data, files);
    console.info(err);
    throw err;
  }
}

export async function putFacturacionOOSS(
  data: Partial<FacturacionOOSSRequest>,
  files: Record<string, File>,
): Promise<any | undefined> {
  try {
    const formData = new FormData();

    Object.entries(files).forEach(([name, value]) => {
      formData.append(name, value);
    });

    formData.append('metadata', JSON.stringify(data));

    const res = await fetch(`${ config.baseUrl }/facturacion-ooss/${data.id}`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        Authorization: getCookie('accessToken'),
      },
      body: formData,
    });

    if (res.status === 400) return responseError();

    if (res.status === 401 && true) {
      return revokeCredentials();
    }

    return res.json();
  } catch (err) {
    console.error('ApiService', 'Error de conexión al hacer PUT de facturación ooss');
    console.info(data, files);
    console.info(err);
    throw err;
  }
}
